import { IBillingStatus } from '../Types/onboarding';
import { formatInsightShortDate } from './formatters';

export type SubscriptionScheduleFields = Pick<
  IBillingStatus,
  'cancel_at_period_end' | 'subscription_ends_at' | 'subscription_status'
>;

/** True when the subscription is scheduled to cancel but access continues until period end. */
export function isSubscriptionCancelScheduled(
  status: SubscriptionScheduleFields
): boolean {
  return Boolean(status.cancel_at_period_end);
}

/** e.g. "Cancels Jun 15, 2026 · Access until then" */
export function formatSubscriptionCancelSchedule(
  status: SubscriptionScheduleFields
): string | null {
  if (!isSubscriptionCancelScheduled(status)) {
    return null;
  }
  if (status.subscription_ends_at) {
    const endDate = formatInsightShortDate(status.subscription_ends_at);
    if (endDate) {
      return `Cancels ${endDate} · Access until then`;
    }
  }
  return 'Subscription scheduled to cancel at the end of your billing period.';
}

/** Compact cancel label for admin table chips (manage modal keeps the full schedule). */
export function formatSubscriptionCancelChipLabel(
  status: SubscriptionScheduleFields
): string {
  if (!isSubscriptionCancelScheduled(status)) {
    return 'Canceling';
  }
  if (status.subscription_ends_at) {
    const endDate = formatInsightShortDate(status.subscription_ends_at);
    if (endDate) {
      return `Cancels ${endDate}`;
    }
  }
  return 'Canceling';
}

/** Short label for admin tables and status chips. */
export function formatSubscriptionEndLabel(
  status: SubscriptionScheduleFields
): string | null {
  const schedule = formatSubscriptionCancelSchedule(status);
  if (schedule) {
    return schedule;
  }
  if (
    status.subscription_status.toUpperCase() === 'CANCELED' &&
    status.subscription_ends_at
  ) {
    const endDate = formatInsightShortDate(status.subscription_ends_at);
    return endDate ? `Ended ${endDate}` : null;
  }
  return null;
}
